import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/**
 * Copyright (c) 2021 lingdocs.com
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
import { makePsString } from "./p-text-helpers";
/**
 * Returns a Pashto string (or string with Length options) ensuring that
 * the accent is on front
 *
 * @param s
 */

export function accentOnFront(s) {
  if ("long" in s) {
    return {
      short: accentOnFront(s.short),
      long: accentOnFront(s.long)
    };
  }

  return Object.assign(Object.assign({}, s), {
    f: accentSyllable(removeAccents(s.f))
  });
}
/**
 * Ensures an accent on a past participle ie. leedúley, préxey, azmóyuley
 *
 * @param s - the Pashto string (with Pashto and Phonetics) to ensure the accent on
 */

export function accentPastParticiple(s) {
  // check for accent placing in words like wáayuley and azmóyuley
  var accentFallsOnThirdLast = function accentFallsOnThirdLast(syls) {
    if (syls.length < 3) return false;
    var secondLast = syls[syls.length - 2];
    var thirdLast = syls[syls.length - 3];
    var lastLetterOfThirdLast = thirdLast.slice(-1);
    return secondLast === "ul" && lastLetterOfThirdLast === "y";
  }; // remove all accents


  var accentsRemoved = removeAccents(s.f); // split up the syllables (preserving the spaces)

  var syllables = splitUpSyllables(accentsRemoved); // add an accent on the appropriate syllable

  var n = accentFallsOnThirdLast(syllables) ? 2 : 1;
  var accentedF = accentFSylsOnNFromEnd(syllables, n);
  return makePsString(s.p, accentedF);
}
export function splitUpSyllables(s) {
  return s.match(/ |([^a|e|i|o|u| ]*(aa|a|ey|ee|e|oo|o|i|u)[^a|e|i|o|u| ]*)/g);
}
/**
 * Returns a phonetic string with the accent placed n syllables from the end
 *
 * @param syls - an array of syllables in phonetic strings without accents (including spaces as extra items)
 * @param n - the number of syllables from the end to put the accent
 */

export function accentFSylsOnNFromEnd(syls, n) {
  return [].concat(_toConsumableArray(syls.slice(0, syls.length - (n + 1))), [accentSyllable(syls[syls.length - (n + 1)])], _toConsumableArray(n !== 0 ? syls.slice(syls.length - n) : [])).join("");
}
export function accentOnNFromEnd(ps, n) {
  var fSyls = splitUpSyllables(removeAccents(ps.f));
  return makePsString(ps.p, accentFSylsOnNFromEnd(fSyls, n));
}

function accentSyllable(s) {
  var replacer = [{
    vowel: "a",
    accented: "á"
  }, {
    vowel: "e",
    accented: "é"
  }, {
    vowel: "i",
    accented: "í"
  }, {
    vowel: "o",
    accented: "ó"
  }, {
    vowel: "u",
    accented: "ú"
  }, {
    vowel: "U",
    accented: "Ú"
  }];
  return s.replace(/a|e|i|o|u|U/, function (match) {
    var r = replacer.find(function (x) {
      return x.vowel === match;
    });
    /* istanbul ignore next */

    return (r === null || r === void 0 ? void 0 : r.accented) || "";
  });
}

export function removeAccents(s) {
  if (typeof s !== "string") {
    return makePsString(s.p, removeAccents(s.f));
  }

  return s.replace(/á/g, "a").replace(/é/g, "e").replace(/í/g, "i").replace(/ó/g, "o").replace(/ú/g, "u").replace(/Á/g, "A").replace(/Ú/g, "U");
}